module.exports = __webpack_public_path__ + "img/Og-graph.2de4e5ee.png";